module.exports = __webpack_public_path__ + "static/video-nfts-background-5321dec7e7a9ab95c8989303099cd4f5.png";